var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"translate",class:_vm.ret_class,style:(_vm.ret_style)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }